import { FC } from "react";
import { useSectionNavigationContext } from "../section-navigation-context";
import { SectionNavigationNavWrapperProps } from "./interfaces";

const SectionNavigationNavWrapper: FC<SectionNavigationNavWrapperProps> = ({
  children,
  className = "",
  ...rest
}) => {
  const { getNavWrapperProps } = useSectionNavigationContext();

  if (!getNavWrapperProps) {
    throw new Error(
      "SectionNavigation.NavWrapper component requires getNavWrapperProps to be defined",
    );
  }

  return <nav {...getNavWrapperProps({ className, ...rest })}>{children}</nav>;
};

export default SectionNavigationNavWrapper;
